import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Describes the nature of an IDC function. Most importantly, delineates direct vs. indirect functions.',
    name: 'IDC Function Type',
    partialId: PartialId.Standard.create('func_idc_type'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
